<template>
  <div id="fzjg">
    <div v-for="(item, index) in list">
      <p><b>序号：</b> {{index + 1}} </p>
      <p><b>分支机构名：</b> {{item.FZJGM}} </p>
      <p><b>所在地：</b> {{item.SZD}} </p>
      <p><b>许可证号：</b> {{item.XKZH}} </p>
      <p><b>设立时间：</b> {{item.SLSJ}} </p>
      <p><b>负责人：</b> {{item.FZR}} </p>
      <p><b>客户服务及投诉电话：</b> {{item.TSDH}} </p>
      <p><b>详细地址：</b> {{item.XXDZ}} </p>
      <p><b>电子邮箱：</b> {{item.DZYX}} </p>
      <div v-if="list.length > 1" class="line"></div>
      <div class="margin-b"></div>
    </div>
  </div>
</template>

<script>
  import ajax from '@/common/ajax/ajax'

  export default {
    name: 'fzjg',
    data () {
      return {
        list: [{xm: '数据读取中'}]
      }
    },
    mounted () {
      this.getData()
    },
    methods: {
      getData () {
        ajax.getFZJG().then(
          data => {
            this.list = data
          }
        )
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// fzjg.vue?d3ebd6e8